/**
 * @file Enrollment Result Card
 */

/**
 * Enrollment Result Card component
 */
const vEnrollmentResultCard = () => {
	const results = document.querySelectorAll( '.v-enrollment-result-card' );

	if ( ! results.length ) {
		return;
	}

	document.addEventListener( 'vPricingCardToggle', ( { detail } ) => {
		const { card, toggle } = detail;

		let url = toggle.getAttribute( 'data-url' );
		if ( sessionStorage.getItem( 'v-enrollment-data' ) ) {
			const enrollData     = JSON.parse( sessionStorage.getItem( 'v-enrollment-data' ) );
			const reportProvider = enrollData[ 'report-provider' ];
			const businessEmail  = enrollData[ 'business-email' ];

			if ( reportProvider ) {
				url = url.replace( '[cra-id]', reportProvider );
			}

			if ( businessEmail ) {
				url = url.replace( '[email]', encodeURIComponent( businessEmail ) );
			}

			// sessionStorage.removeItem( 'v-enrollment-data' );
		}
		toggle.setAttribute( 'data-url', url );

		[ ...results ].filter( ( result ) => result.contains( card ) )
			.forEach( ( result ) => {
				const priceSpan       = result.querySelector( '.v-enrollment-result-card__price' );
				const cta             = result.querySelector( '.v-enrollment-result-card__cta-btn' );
				priceSpan.textContent = toggle.getAttribute( 'data-price' );

				if ( cta ) {
					cta.href = toggle.getAttribute( 'data-url' );
				}
			} );
	} );
};

export default vEnrollmentResultCard;
